import { gql } from '@apollo/client';
const GET_CONVERSATION = gql `
  query GetConversation($url: String!) {
    me {
      id
      conversation(pageUrl: $url) {
        id
        title
        type
        members {
          edges {
            node {
              id
              user {
                id
                username
                email
                avatar
              }
            }
          }
        }
        messages {
          edges {
            node {
              sender {
                id
                username
                email
                avatar
              }
              id
              text
              createdDate
              image
              sendByMe
              mentions {
                id
                user {
                  id
                  username
                  email
                  avatar
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_CONVERSATION;
